import React from "react";

/**
 * Bloquea toda interacción del formulario cuando la tarea NO está asignada
 * al usuario que la abrió (xflow_front manda ?locked=true en ese caso, ver
 * GenericForm.js del front). El overlay cubre 100% del contenido con
 * pointer-events activos (captura todo click/tap) y no deja pasar nada al
 * contenido de abajo.
 */
const LockOverlay = ({ visible, message }) => {
  if (!visible) return null;
  return (
    <div className="xext-lock-overlay" role="alert" aria-live="assertive">
      <div className="xext-lock-card">
        <span className="xext-lock-icon" aria-hidden="true">🔒</span>
        <p>{message || "Esta tarea está asignada a otro usuario. Solo puedes visualizarla."}</p>
      </div>
    </div>
  );
};

export default LockOverlay;
